










































import { Component, Vue } from "vue-property-decorator";
import { LAPORAN_RP1_CARDS } from "@/config/sidebar-menu";

interface LaporanRp1Card {
  report: string;
  route?: string;
  title: string;
  subtitle: string;
  desc: string;
  icon: string;
  color: string;
}

@Component
export default class LaporanRp1MenuPage extends Vue {
  readonly cards = LAPORAN_RP1_CARDS;

  goto(card: LaporanRp1Card) {
    if (card.route) {
      this.$router.push({ name: card.route }).catch(() => undefined);
      return;
    }
    this.$router.push({ name: "rl1-ranap", query: { report: card.report } });
  }
}
